import { mountVueComponent } from '@/lib/mount-vue-component';

export default () =>
  import('@/modules/notifications/components/NotificationForm').then(NotificationForm => {
    mountVueComponent('notification-form', NotificationForm);
  });
